import openai from '../config/openaiConfig';

// Supporting AI writing

// Function to check the run status periodically
// export const checkRunStatusOnMagicDraft = async (runThreadId, runId, messageIndexToFetch) => {
//     const maxRetries = 30; // Maximum number of retries
//     const delay = 2000; // Delay between retries in milliseconds
//     let retries = 0;

//     while (retries < maxRetries) {
//         const runStatus = await openai.beta.threads.runs.retrieve(runThreadId, runId);

//         if (runStatus.status === 'completed') {
//             console.log("Run completed, fetching messages.");
//             // Once the run is completed, fetch the thread messages
//             const messagesResponse = await openai.beta.threads.messages.list(runThreadId, { order: 'asc', limit: 100 });
//             const messages = messagesResponse.data;

//             if (messages && messages.length > 0) {
//                 console.log("Messages fetched successfully:", messages);
//                 // return messages[1].content[0].text.value; // Assuming the second message contains the answer
//                 return messages[messageIndexToFetch].content[0].text.value; // Assuming the second message contains the answer
//             }
//         } else if (runStatus.status === 'failed') {
//             console.error("Run failed with error: ", runStatus.last_error.code, ". ", runStatus.last_error.message);
//             return { error: runStatus.error }; // Return error details for appropriate error handling
//         } else {
//             console.log("Run still in progress, checking status again after a delay.");
//             // If the run is still in progress, check again after a delay
//             await new Promise(resolve => setTimeout(resolve, delay)); // Check every 2 seconds
//             retries++;
//         }
//     }

//     console.error("Run status check timed out.");
//     return { error: "Run status check timed out." };
// };

// AI Writing

// export const generateMagicFirstDraftWithOpenAi = async (program, documentInstructions, funderDescription, funderState = null, funderName = null) => {        
export const generateMagicFirstDraftWithOpenAi = async (organizationName, programName, programLocation, programDescription, funderName, funderState, funderDescription, documentInstructions ) => {        

    let response;

    try {
        response = await openai.chat.completions.create({
            model: "gpt-4o",            
            messages: [
                { role: "system", content: `You are the world's best grant writer for nonprofits. Your nonprofit is called ${organizationName}.`},
                { role: "system", content: `Your nonprofit has the following program: ${programName}, based in ${programLocation}. The program description is: ${programDescription}.`},
                { role: "user", content: `You are applying for a grant opportunity from a funder with the name ${funderName} in the state of ${funderState}. The funder has the following description: ${funderDescription}.`},                
                { role: "user", content: `Write a clear and concise document using the following instructions: ${documentInstructions}`},
                { role: "user", content: "Do not reply with templates / placeholders. Make the document as personalized as possible to the funder."},
                { role: "user", content: "For cover letters and LOIs, don't include addresses up at the top. Just include document body."},
                { role: "user", content: "Do not hallucinate stats or accomplishments. Only include what you know is true."},
            ],
            temperature: 0.1,
            n: 1,
        });        
    } catch (error) {
        console.error("Failed to get response from OpenAI:", error);
        throw error;
    }

    let documentText = response.choices[0].message.content;
    console.log("Extracted document content:", documentText);

    return documentText;
};

// AI Editing
// export const generateAiEditForExcerpt = async (editingInstructions, highlightedText) => {
//     if (!editingInstructions.trim()) {
//         throw new Error("Editing instructions cannot be empty.");
//     }

//     const response = await openai.chat.completions.create({
//         model: "gpt-4o",
//         messages: [
//             { role: "system", content: "You are the world's best grant writer, working for a nonprofit."},
//             { role: "user", content: `Edit the following text using these instructions: ${editingInstructions}. Text to edit: ${highlightedText}`},
//         ],
//         temperature: 0.4,
//         n: 1,
//     });

//     if (!response || !response.choices || response.choices.length === 0) {
//         throw new Error("Invalid response from OpenAI API: 'response' or 'response.choices' is undefined");
//     }

//     return response.choices[0].message.content;
// };

